import Radio from 'backbone.radio';
import NavView from '@/views/nav/view';

var globalCh = Radio.channel('global');

var collection;
/**
 * @param Object options should include nav_items
 *
 */
function show_secondary_nav(options) {
    var app_layout = globalCh.request('app_layout');
    var region = app_layout.getRegion('secondary_nav');
    var profile_region = app_layout.getRegion('profile_nav');

    // Profile nav should never show when secondary is active
    if (profile_region.hasView()) {
        profile_region.destroy();
    }

    if (region.isDestroyed()) return;

    options = options || {};

    if ( options.empty ) {
        region.show(new NavView({
            collection: null
        }));
        // UX requested left nav be hidden if it is empty
        region.$el.hide();
        return;
    } else if ( region.$el ) {
        region.$el.show();
    }

    // A quick way to blow away the sidebar nav is to call
    // show_secondary_nav without a collection
    if (!options.collection) {
        region.reset();
        collection = null;
        return;
    }
    
    if ((collection !== options.collection || options.reset) || !region.collection) {
        region.show(new NavView({ 
            className: options.category || '',
            collection: options.collection,
            childView: options.childView,
            childViewOptions: options.childViewOptions
        }));
        collection = options.collection;
    }
}
export default show_secondary_nav;
